<template>
  <el-card :style="display_style[appType]" class="resetPass">
    <div style="text-align: left">
      <el-button style="text-align: left" @click="handleBack" size="small">
        <i style="font-size: 16px" class="el-icon-back" /> 返回
      </el-button>
    </div>
    <div class="logintext">
      <h4> 重置密码 </h4>
    </div>
    <div class="formdata" style="text-align: left">
      <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="100px" size="small">
        <el-form-item prop="accountName" label="手机号或邮箱">
          <el-input v-model="form.accountName" clearable placeholder="请输入手机号或邮箱" />
        </el-form-item>
        <el-form-item prop="accountPassword" label="新密码">
          <el-input v-model="form.accountPassword" clearable placeholder="请输入密码" show-password />
        </el-form-item>
        <el-form-item prop="accountPassword2" label="确认密码">
          <el-input v-model="form.accountPassword2" clearable placeholder="请再次输入密码" show-password />
        </el-form-item>
        <el-form-item prop="veriCode" label="验证码">
          <el-row :gutter="4">
            <el-col :span="12">
              <el-input v-model="form.veriCode" clearable placeholder="请输入验证码" style="width: 100%"/>
            </el-col>
            <el-col :span="8">
              <el-button @click="getVeriCode" type="primary" :disabled="canClick"> {{ content }} </el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
    <div class="butt">
      <el-button :loading="loading" type="primary" style="width:100%;" @click.native.prevent="handleSubmit">
        <span v-if="!loading"> 确 定 </span>
        <span v-else> 修 改 中... </span>
      </el-button>
    </div>
  </el-card>
</template>

<script>
import Config from "@/config"
import { getVeriCode } from "@/api/login"
import {getAccountType, getAppType, getUUID, notify, validateContact, validatePass} from "@/utils/util"

export default {
  name: "reset",
  props: {
    appType: {
      type: String,
      default: "CERTIFICATION_PC"
    }
  },
  data () {
    const validateUniformity = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.accountPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    }
    return {
      display_style: {CERTIFICATION_MOBILE: "width: 80%; min-width: 300px", CERTIFICATION_PC: "width: 30%"},
      resetPass: false,
      loading: false,
      form: {
        accountName: "",
        accountPassword: "",
        accountPassword2: "",
        accountType: "",
        veriCode: ""
      },
      rules: {
        accountName: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        accountPassword: [
            { required: true, message: "请输入密码", trigger: "blur" }, {validator: validatePass, trigger: "blur"}
        ],
        accountPassword2: [
          {required: true, message: "请再次输入密码", trigger: "blur"},
          {validator: validateUniformity, trigger: "blur"}, {validator: validatePass, trigger: "blur"}
        ],
        accountType: [{ required: true, message: "请输入手机号或邮箱", trigger: "blur" }, {validator: validateContact, trigger: "blur"}],
        veriCode: [{ required: true, message: "请输入验证码", trigger: "blur" } , {min: 6, max: 6, message: '验证码为 6 位', trigger: 'blur'}]
      },
      content: "发送验证码",
      totalTime: 60,
      canClick: false
    }
  },
  watch: {
    appType: function () {
      console.log("appType", this.appType)
    }
  },
  methods: {
    handleBack () {
      this.$emit("back")
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    handleSubmit () {
      this.loading = true
      this.$refs.form.validate(valid => {
        if (valid) {
          const submitData = {
            accountName: this.form.accountName,
            accountPassword: this.form.accountPassword,
            veriCode: this.form.veriCode,
            accountType: getAccountType(),
            terminalUUID: getUUID()
          }
          this.$emit('submit', submitData, response => {
            this.loading = false
            if (response) {
              this.resetForm()
            }
          })
        } else {
          this.loading = false
          notify(Config.notifyErr, Config.submitErr)
        }
      })
    },
    getVeriCode () {
      if (this.canClick) return
      if (!this.form.accountName) {
        notify(Config.notifyWarn, "请先输入手机号或邮箱!")
      } else {
        const params = {
          accountName: this.form.accountName,
          accountType: getAccountType(),
          appType: getAppType(),
          terminalUUID: getUUID()
        }
        getVeriCode(params).then(response => {
          if (response.error_code === 0) {
            notify(Config.notifySuc, "验证码发送成功！")
            this.canClick = true
            const clock = window.setInterval(() => {
              this.totalTime--
              this.content = this.totalTime + 's后重新发送'
              if (this.totalTime < 0) {
                window.clearInterval(clock)
                this.content = '重新发送验证码'
                this.totalTime = 60
                this.canClick = false
              }
            }, 1000)
          } else {
            notify(Config.notifyErr, Config.errorMsg[response.error_code])
          }
        }).catch(error => {
          console.log(error)
          notify(Config.notifyErr, Config.serverErrorMsg)
        })
      }
    }
  }
}
</script>

<style scoped>
.el-card {
  transform: translate(-50%);
  margin-left: 50%;
  margin-top: 10%;
}

.logintext {
  text-align: center;
  font-size: 20px;
  font-weight: bolder;
  color: black;
}
</style>